import React, { useEffect, useRef, useState } from 'react';
import './cohort-mcs.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '@/components/back-button/back-button.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faAward, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { ModalAlert } from '@/components/SHARED/modal/modal.component';

const CohortMcs = ({
    mcList,
    cohorts
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const { cohortPath } = useParams();
    const [ selectedCohort, setSelectedCohort ] = useState(null);
    const [ availableMcs, setAvailableMcs ] = useState([]);
    const [ availToDisplay, setAvailToDisplay ] = useState([]);
    const [ cohortMcs, setCohortMcs ] = useState([]);
    const [ selectedMcs, setSelectedMcs ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const cohortRef = useRef();
    const selectedRef = useRef([]);
    const approveRef = useRef();
    const navigate = useNavigate();
    const directionRef = useRef();

    useEffect(() => {
        if (!mcList || !cohorts || !cohortPath) return;
        let cohort = Object.values(cohorts).filter(c => c.path === cohortPath)[0];
        cohortRef.current = cohort;
        setSelectedCohort(cohortRef.current);
        
    }, [mcList, cohorts, cohortPath])

    useEffect(() => {
        if (!selectedCohort) return;
        const avail = Object.values(mcList)
            .filter(m => 
                !selectedCohort.mcList.includes(m.mc_key)
            ).sort((a, b) => 
                a.name.toLowerCase() > b.name.toLowerCase() 
                ? 1 
                : -1
            );
        setAvailableMcs(avail);
        setAvailToDisplay(avail);
        setCohortMcs(
            Object.values(mcList)
            .filter(m => 
                selectedCohort.mcList.includes(m.mc_key)
            ).sort((a, b) => 
                a.name.toLowerCase() > b.name.toLowerCase() 
                ? 1 
                : -1
            )
        )
    }, [selectedCohort])

    function searchMcs(text) {
        if (!text) {
            setAvailToDisplay([...availableMcs]);
            return;
        }
        let avail = [...availableMcs]
            .filter(m => 
                m.name.toLowerCase().includes(text.toLowerCase()) ||
                m.name.toLowerCase().includes(text.toLowerCase())
            )
            .sort((a, b) => 
                a.name.toLowerCase() > b.name.toLowerCase() 
                ? 1 
                : -1
            )
        setAvailToDisplay(avail);
    }

    function toggleMcToSelectedList(dir, mc_key) {
        let tempArr = [...selectedRef.current];
        console.log(directionRef.current);
        if (dir !== directionRef.current) {
            directionRef.current = dir;
            tempArr = [];
        }
        if (!tempArr.includes(mc_key)) {
            tempArr.push(mc_key);
        } else {
            tempArr.splice(tempArr.indexOf(mc_key), 1)
        }
        selectedRef.current = [...tempArr];
        setSelectedMcs(selectedRef.current);
    }

    function moveMcs(e) {
        if (e !== directionRef.current) return;
        console.log(e);
        let tempCohort = {...selectedCohort};
        let tempMcList = [...tempCohort.mcList];
            
        if (e === 'add') {
            tempMcList = [
                ...tempMcList,
                ...selectedRef.current
            ]
            
        } else {
            for (let mc_key of selectedRef.current) {
                tempMcList.splice(tempMcList.indexOf(mc_key), 1);
            }
        }
        tempCohort.mcList = tempMcList;
        cohortRef.current = {...tempCohort};
        setSelectedCohort(cohortRef.current);
        console.log(tempCohort);
        selectedRef.current = [];
        setSelectedMcs(selectedRef.current);
        directionRef.current = null;
        document.getElementById('search-input').value = '';
    }

    async function handleSubmit() {
        setLoading(true);
        let tempCohort = {...cohortRef.current};
        tempCohort.ts = new Date().getTime();
        const res = await UseCloudFunction(
            'saveCohort',
            {
                'cohort': tempCohort,
                'cst_key': userProfile.cst_key
            }
        )
        console.log(res);
        setLoading(false);
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
            return;
        }   
        setAlertMessage('Micro-Credentials saved successfully!');
        approveRef.current = () => {
            navigate(-1);
        }
    }

    return (
        <div className='cohort-mcs'>
            <BackButton cancel={() => navigate(-1)} />
            <div className='section-title with-left-icon'>
                <FontAwesomeIcon icon={faAward} />
                Manage Cohort Micro-Credentials
            </div>
            <hr />
            <div className="cohort-mcs-grid">
                <div className='mcs-left-col'>
                    <div>
                        Choose Micro-Credentials(s)
                    </div>
                    <div className="g-space-0-5"></div>
                    <div className='g-list-item'>
                        <div className='search-bar small'>
                            <div className='field small'>
                                <input 
                                    text='text'
                                    id='search-input' 
                                    onChange={(e) => searchMcs(e.target.value)} />
                            </div>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </div>
                        <div className='available-list-box'>
                            {
                                (availToDisplay) &&
                                availToDisplay
                                .map(m => {
                                    return (
                                        <button 
                                            key={m.mc_key}
                                            className={`g-button text-only available-mc-item ${
                                                selectedMcs.includes(m.mc_key) 
                                                ? 'primary' 
                                                : ''
                                            }`}
                                            onClick={() => toggleMcToSelectedList('add', m.mc_key)} >
                                            <img src={m.imageUrl} className='mc-icon' />
                                            <div className='mc-name'>{m.name}</div>
                                        </button>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='mcs-center-col'>
                    <button 
                        className='g-button med-btn'
                        onClick={() => moveMcs('add')}>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button 
                        className='g-button med-btn'
                        onClick={() => moveMcs('remove')}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                </div>
                <div className='mcs-right-col'>
                    <div>
                        Selected Micro-Credentials
                    </div>
                    <div className="g-space-0-5"></div>
                    <div className='g-list-item selected-list-box'>
                        {
                            (cohortMcs) &&
                            cohortMcs
                            .map(m => {
                                return (
                                    <button 
                                        key={m.mc_key}
                                        className={`g-button text-only available-mc-item ${
                                            selectedMcs.includes(m.mc_key) 
                                            ? 'primary' 
                                            : ''
                                        }`}
                                        onClick={() => toggleMcToSelectedList('remove', m.mc_key)} >
                                        <img src={m.imageUrl} className='mc-icon' />
                                        <div className='mc-name'>{m.name}</div>
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="g-space-2"></div>
            <div className='buttons'>
                {
                    (loading)
                    ?
                    <>
                    <button className='g-button'>Cancel</button>
                    <button className='g-button'><ThreeDotsLoader /></button>
                    </>
                    :
                    <>
                    <button 
                        className='g-button'
                        onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                    <button 
                        className='g-button primary'
                        onClick={() => handleSubmit()}>
                        Save Changes
                    </button>
                    </>
                }
            </div>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default CohortMcs